import { EMPTY_OBJ } from '@constants';
import notification from '@atoms/Notification';

import mutationFactory from './mutationFactory';
import useQuery from './useQuery';

import api from '..';

export const useGetTranslations = (queryConfig = {}) => {
  const queryResult = useQuery(['translations'], api.translations.get, {
    onError: (error) => {
      if (error?.response?.status !== 404) {
        notification.error({ message: error.message });
      }
    },
    ...queryConfig,
  });

  return {
    translations: queryResult.data || EMPTY_OBJ,
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'translations' });

export const useTranslate = createMutation(api.translations.translate);
